import { SET_PRICING } from '../types/pricing';

export const setPricing = (pricing) => {
  return {
    type: SET_PRICING,
    payload: pricing
  };
};
